import { render, staticRenderFns } from "./PhoneAreaCodeSelect.vue?vue&type=template&id=964a691c&scoped=true"
import script from "./PhoneAreaCodeSelect.vue?vue&type=script&lang=js"
export * from "./PhoneAreaCodeSelect.vue?vue&type=script&lang=js"
import style0 from "./PhoneAreaCodeSelect.vue?vue&type=style&index=0&id=964a691c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964a691c",
  null
  
)

export default component.exports